// extracted by mini-css-extract-plugin
export default {"cls1":"HashtagSelector-cls1__Mp","cls2":"HashtagSelector-cls2_xsV HashtagSelector-cls1__Mp"};